import { LOCATIONS } from "./locations";
import { SERVICES } from "./services";

export const slugify = (s) =>
  s
    .toLowerCase()
    .replace(/'/g, "")
    .replace(/&/g, "and")
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-|-$/g, "");

export const districtTitle = (d) => d.replace(/ (approach|area)$/i, "");

export const SUB_AREAS = (() => {
  const seen = {};
  const out = [];
  for (const town of LOCATIONS) {
    for (const district of town.districts) {
      let slug = slugify(district);
      if (seen[slug]) slug = `${slug}-${town.slug}`;
      seen[slug] = true;
      out.push({ district, slug, town });
    }
  }
  return out;
})();

export const getSubArea = (slug) => SUB_AREAS.find((a) => a.slug === slug);

export const nearbySubAreas = (area) =>
  SUB_AREAS.filter((a) => a.town.slug === area.town.slug && a.slug !== area.slug);

const COPY = {
  "tyre-fitting": {
    p1: (d, t) =>
      `A flat or worn-out tyre in ${d} doesn't need a garage trip. Our mobile fitting van covers ${d} and the rest of ${t.name} every day, carrying tyres from budget to premium — Michelin, Pirelli, Continental, Goodyear and more. Send your registration on WhatsApp and we'll confirm the correct tyre and a fixed price, then fit them outside your door.`,
    p2: (d, t) =>
      `${d} is part of our ${t.name} coverage area (${t.postcodes}, main routes ${t.routes}), so whether you're at home, at work or stuck roadside, fitting, balancing and old-tyre disposal all happen at your location. The visit usually takes well under an hour.`,
  },
  "puncture-repair": {
    p1: (d, t) =>
      `Picked up a nail in ${d}? Our repair vans cover ${d} and all of ${t.name} 24/7, arriving with the full BS AU 159 repair kit — plugs, patches, valves and compressors. We assess the damage at your location, repair it properly if it's safe to do so, and if it isn't, we fit a new tyre on the spot.`,
    p2: (d, t) =>
      `Response across ${d} and the wider ${t.name} area is typically ${t.eta}, day or night. Every repair is pressure-tested before we leave, and you'll get honest advice — we only repair the central tread zone, never the sidewall or shoulder.`,
  },
  "wheel-alignment": {
    p1: (d, t) =>
      `If your car pulls left through ${d}'s streets or your tyres are wearing on one edge, our mobile laser alignment service comes to you. We measure toe, camber and castor at your home or workplace in ${d}, adjust to manufacturer settings and centre your steering wheel — usually within the hour.`,
    p2: (d, t) =>
      `Serving ${d} and the wider ${t.name} area (${t.eta} typical response), we show before-and-after readings on every job. After a pothole or kerb strike, an alignment costs a fraction of the tyres it saves.`,
  },
  "summer-tyres": {
    p1: (d, t) =>
      `When temperatures climb above 7°C, summer tyres out-brake and out-grip all-seasons on every road around ${d}. We supply and fit summer tyres from Michelin, Pirelli, Continental, Goodyear and more — at your ${d} home or workplace, balanced and torqued to manufacturer spec.`,
    p2: (d, t) =>
      `${d} sits inside our ${t.name} coverage (${t.postcodes}), with typical response of ${t.eta}. Your old set goes away for recycling, pressures are set and TPMS reset — ready for the warm months without a single garage queue.`,
  },
  "winter-tyres": {
    p1: (d, t) =>
      `Below 7°C, winter tyres transform cold-morning grip — exactly what you want on the roads around ${d}. We fit 3PMSF-certified winter tyres from Michelin, Continental, Goodyear and more at your ${d} home or office, balanced and pressure-set for the season.`,
    p2: (d, t) =>
      `As part of our ${t.name} coverage (${t.eta} typical response), we recommend booking your winter swap before the first frost — demand spikes when the cold snap lands, and booking early gets you the pick of sizes and brands.`,
  },
  "seasonal-tyres": {
    p1: (d, t) =>
      `Running summer and winter sets in ${d}? Our seasonal switchover brings the right set to your driveway — swapped, balanced and pressure-set in a single visit, with reminders each spring and autumn so you never miss the changeover window.`,
    p2: (d, t) =>
      `${d} is inside our ${t.name} patch (${t.eta} typical response). Register once and the twice-yearly swap becomes a one-hour visit at your door — no garage queues, ever.`,
  },
};

export const subAreaServiceContent = (service, area) => {
  const d = districtTitle(area.district);
  const t = area.town;
  const nameForTitle =
    service.slug === "seasonal-tyres" ? "Seasonal Tyre Changeover" : service.shortName;
  return {
    title: `${nameForTitle} in ${d}`,
    p1: COPY[service.slug].p1(d, t),
    p2: COPY[service.slug].p2(d, t),
    faqs: [
      {
        q: `Do you cover ${d}?`,
        a: `Yes — ${area.district} is inside our ${t.name} coverage area (${t.postcodes}). Typical response is ${t.eta}, 24 hours a day, 7 days a week.`,
      },
      {
        q: `How much does ${service.shortName.toLowerCase()} cost in ${d}?`,
        a: `Pricing depends on your tyre size and the brand — send your registration on WhatsApp or call the dispatch line and you'll get a fixed quote before the van moves. Fitting, balancing and old-tyre disposal are always included.`,
      },
      {
        q: `How fast can you reach me in ${d}?`,
        a: `Typically ${t.eta} anywhere across ${t.name}, including ${area.district}. Peak traffic or severe weather can add a little — we'll always give you an honest ETA when you book.`,
      },
    ],
  };
};
